import cn from "classnames"

export default function TitleBanner({ blok }) {
  return (
    <section className="bg-green-sea px-8 overflow-hidden">
      <div className="max-w-screen-xl mx-auto lg:flex lg:min-h-[200px]">
        <div className="lg:min-w-[450px] w-full py-10 self-center">
          <h1 className="text-black">{blok.heading}</h1>
          {blok?.subheading ? <h2 className="text-black uppercase text-m1">{blok.subheading}</h2> : null}
        </div>
        <div
          className={cn("min-w-[100dvw] bg-fixed -ml-8 lg:-ml-0 h-32 lg:h-auto bg-[length:1800px]", {
            "bg-dog-banner": blok.pattern === "dog",
            "bg-cat-banner": blok.pattern === "cat",
          })}
          aria-hidden
        />
      </div>
    </section>
  )
}
